// JsFromRoutes CacheKey ee10a634e071c7eafddc31aa518d63e7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/order/confirmation/:order_number/:buyer_token/contacts'),
}
